<p>assign-flow-setting works!</p>
